import { FC } from "react";

const VideoPoster: FC<{ poster: string }> = ({ poster }) => {
  return (
    <div className="absolute inset-0 pointer-events-none">
      <img
        src={poster}
        alt="Poster"
        decoding="async"
        fetchPriority="high"
        loading="eager"
        className="h-full w-full object-contain"
      />
    </div>
  );
};

export default VideoPoster;
